import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const verandaApi = {
  getAnalyticSatisfactionHistory: (request) => {
    const { config } = request
    return instance().get(`/analytics/veranda/more/satisfactions_history`, config)
  }
}
export default verandaApi



// WEBPACK FOOTER //
// ./src/api/veranda.js